import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@mui/material/IconButton'
import { withStyles } from '@material-ui/core/styles'
import { specialTheme } from '../theme'

const TooltipStyle = withStyles({
  tooltip: {
    color: 'black !important',
    fontSize: '0.9rem',
    fontWeight: 400,
    padding: '10px',
    lineHeight: '16px',
    textAlign: 'center',
    fontFamily: specialTheme.font.fontFSMe,
    backgroundColor: '#eeeeee !important',
    width: 300,
    height: 'auto',
  },
})(Tooltip)

interface QuestionMarkProps {
  text: string
  position?: string
  height?: number
}

export const QuestionMark = (props: QuestionMarkProps) => {
  return (
    <TooltipStyle title={props.text}>
      <IconButton
        sx={{
          color: '#fff',
          backgroundColor: '#8b003a !important',
          width: props.height ?? '18px',
          height: props.height ?? '18px',
          fontSize: '16px',
          borderRadius: 0,
          left: props.position || '3px',
          '&:hover': {
            backgroundColor: '#c4112f !important',
          },
          order: 999,
          alignSelf: 'center',
          // padding: '0.2rem',
        }}
      >
        ?
      </IconButton>
    </TooltipStyle>
  )
}
